<p-table styleClass="p-datatable-striped" [columns]="cols" sortField="transactionId" [value]="businessTransactionDetails"
    [customSort]="false" (onSort)="onSort()" #dt #table>
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..."
                    (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Select Group</th>
            <th>Select Request</th>
            <th *ngFor="let column of columns" [pSortableColumn]="column.field">{{column.header}}<p-sortIcon [field]="column.field"></p-sortIcon></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-businessTransaction let-rowIndex="rowIndex">
        <tr>
            <td *ngIf="rowGroupMetadata[businessTransaction.transactionId].index === rowIndex"
                [attr.rowspan]="rowGroupMetadata[businessTransaction.transactionId].size">
                <a href="javascript:void(0)"
                    (click)="toggleAllForBusinessTransaction($event, businessTransaction.transactionId)"><input
                    type="checkbox" *ngIf="isFirstRecordForTransaction(businessTransaction)"
                    [ngModel]="allCheckedForBusinessTransactionNumber(businessTransaction.transactionId)" />
                </a>
            </td>
            <td>
                <input type="checkbox" [(ngModel)]="businessTransaction.checked" />
            </td>
            <td *ngFor="let col of cols">
                <ng-container [ngSwitch]="col.header">
                    <ng-container *ngSwitchCase="'Service'">
                        <a href="javascript:void(0)"
                            (click)="redirectToMyTransaction(businessTransaction)">{{businessTransaction.transactionType}}</a>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Reason'">
                        <a ifSecurityTransaction="ServiceEscalationManagement" href="javascript:void(0)"
                            (click)="openModal(businessTransaction)">{{businessTransaction.escalationType}} </a>
                        <p ifDoesntHaveSecurityTransaction="ServiceEscalationManagement">
                            {{businessTransaction.escalationType}}</p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{businessTransaction[col.field]}}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-columns>
        <tr>
            <td colspan="12" class="footer__toggle">
                <div class="footer__no-results" *ngIf="businessTransactionDetails?.length <= 0">No Current Escalations</div>
                <div class="row" ifSecurityTransaction="ServiceEscalationManagement" *ngIf="businessTransactionDetails?.length > 0">
                    <div class="col-sm-2 mvd_form-group">
                        <label>&nbsp;</label>
                        <a class="icon--select" href="javascript:void(0)" (click)="toggleAll()"> Toggle All</a>
                    </div>
                    <div class="col-sm-3 col-md-2 mvd_form-group">
                        <label>Action</label>
                        <p-dropdown appendTo="body" [options]="dropdownActionOptions" [(ngModel)]="selectedActionOption"></p-dropdown>
                    </div>
                    <div class="col-sm-3 col-lg-2 mvd_form-group" *ngIf="showAssignmentOptions()">
                        <label>Send To</label>
                        <p-dropdown appendTo="body" [options]="dropdownAssignmentOptions" [(ngModel)]="selectedAssignmentOption"></p-dropdown>
                    </div>
                    <div class="col-sm-2 mvd_form-group">
                        <mvm-spinner-btn [isDisabled]="disableGoButton()" [isLoading]="showButtonLoading" [btnText]="'Send'" (clicked)="onGoButtonClicked()"></mvm-spinner-btn>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
